import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DropdownService {
  private openedComponentSource = new Subject<any>();
  openedComponent$ = this.openedComponentSource.asObservable();

  notifyOpen(component: any) {
    this.openedComponentSource.next(component);
  }
}
